module.exports = __webpack_public_path__ + "static/media/bill-to-ship-to-sample-1.b29e2185.png";